import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAlertStore } from "@/stores/alert-store";
import { CheckCircle, XCircle } from "lucide-react";

interface AlertRendererProps {
  className?: string;
}

export const AlertRenderer: React.FC<AlertRendererProps> = ({
  className = "",
}) => {
  const { currentAlert, isOpen, hideAlert } = useAlertStore();

  if (!currentAlert) return null;

  const getIcon = () => {
    switch (currentAlert.variant) {
      case "destructive":
        return <XCircle className="h-6 w-6 text-destructive" />;
      case "default":
      default:
        return <CheckCircle className="h-6 w-6 text-green-600" />;
    }
  };

  const getTitleColor = () => {
    switch (currentAlert.variant) {
      case "destructive":
        return "text-destructive";
      case "default":
      default:
        return "text-green-600";
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && hideAlert()}>
      <DialogContent className={`max-w-md ${className}`}>
        <DialogHeader>
          <div className="flex items-center gap-3">
            {getIcon()}
            <div className="flex-1">
              {currentAlert.title && (
                <DialogTitle className={getTitleColor()}>
                  {currentAlert.title}
                </DialogTitle>
              )}
              <DialogDescription className="mt-2">
                {currentAlert.description}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="flex justify-end mt-4">
          <Button onClick={hideAlert} variant="outline">
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
